import { Component, ElementRef, EventEmitter, Input, OnInit, ViewChild, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, ButtonLoader } from '../../../../../core';
import { UsuarioFilter } from '../../../filter';
import { usuarioAtivo } from '../../../usuario-situacao';
import { UsuarioAgrupamentoPerfil } from '../../../usuario-agrupamento-perfil';
import { Usuario } from '../../../usuario';
import { UsuarioPopula } from '../../usuario-popula';
import { UsuarioPopulavel } from '../../usuario-populavel';
import { UsuarioPopulaAgrupamentoPerfil } from '../usuario-popula-agrupamento-perfil';
import { UsuarioAgrupamentoHttpService } from '../../../services';

@Component({
    selector: 'sgt-usuario-popula-agrupamento-perfil-modal',
    templateUrl: './usuario-popula-agrupamento-perfil-modal.component.html',
    styleUrls: ['./usuario-popula-agrupamento-perfil-modal.component.less']
})
export class UsuarioPopulaAgrupamentoPerfilModalComponent implements OnInit {
    @Input() title = 'Adicionar usuários';
    @Input() subtitle = 'Selecione os usuários que deseja adicionar';
    @Input() entitiesAdicionadas: UsuarioPopulavel[];
    elModal: any;

    @ViewChild('form') form: NgForm;
    isLoading: boolean;
    isLoadingFinished: boolean;
    allSelected: boolean;
    agrupamentosPopula: UsuarioPopulaAgrupamentoPerfil[];

    @Output() adicionar = new EventEmitter<Usuario[]>();

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private usuarioAgrupamentoHttpService: UsuarioAgrupamentoHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.search();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        this.agrupamentosPopula = [];
        this.allSelected = false;
    }

    open() {
        this.clear();
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Pesquisa os usuários ativos agrupados pelo perfil */
    private search() {
        this.isLoading = true;
        this.isLoadingFinished = false;

        const filter = new UsuarioFilter();
        filter.situacao = usuarioAtivo.id;
        this.usuarioAgrupamentoHttpService.searchAgrupamentosPerfil(filter)
            .subscribe(
                agrupamentos => {
                    this.createPopula(agrupamentos);
                    this.isLoading = false;
                    this.isLoadingFinished = true;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao pesquisar os usuários', error);
                    this.isLoading = false;
                    this.isLoadingFinished = true;
                }
            )
    }

    /** Cria os objetos utilizados para adicionar os usuários agrupados pelo perfil */
    private createPopula(agrupamentos: UsuarioAgrupamentoPerfil[]) {
        this.agrupamentosPopula = [];
        if (!agrupamentos) {
            return;
        }

        // Agrupamentos
        agrupamentos.forEach(agrupamento => {
            const agrupamentoPopula = new UsuarioPopulaAgrupamentoPerfil(agrupamento.perfil, agrupamento.nomePerfil);
            // Usuários
            agrupamento.usuarios?.forEach(usuario => {
                const entityPopula = new UsuarioPopula(usuario);
                entityPopula.exists = this.isExists(usuario.id);
                agrupamentoPopula.usuarios.push(entityPopula);
            });

            this.agrupamentosPopula.push(agrupamentoPopula);
        });
    }

    /** Verifica se o usuário já existe nos usuários já adicionados */
    private isExists(idUsuario: number): boolean {
        if (!this.entitiesAdicionadas) {
            return false;
        }

        for (let i = 0; i < this.entitiesAdicionadas.length; i++) {
            const entityAdicionada = this.entitiesAdicionadas[i];
            if (entityAdicionada.idUsuario === idUsuario) {
                return true;
            }
        }

        return false;
    }

    /** Verifica se possui algum agrupamento e usuários */
    possuiAgrupamentos(): boolean {
        return this.agrupamentosPopula && this.agrupamentosPopula.length > 0;
    }

    /** Ao alterar a opção de selecionar todos os usuários */
    onChangeAllSelected(value: boolean) {
        this.agrupamentosPopula?.forEach(agrupamentoPopula => {
            agrupamentoPopula.usuarios?.forEach(entityPopula => {
                if (!entityPopula.exists) {
                    entityPopula.selected = value;
                }
            });
        });
    }

    /** Ao alterar a seleção de um usuário */
    onChangeSelected() {
        let allSelected = true;
        // Agrupamentos
        for (let i = 0; i < this.agrupamentosPopula?.length; i++) {
            const agrupamentoPopula = this.agrupamentosPopula[i];
            // Usuários
            for (let j = 0; j < agrupamentoPopula.usuarios?.length; j++) {
                const entityPopula = agrupamentoPopula.usuarios[j];
                if (!entityPopula.selected && !entityPopula.exists) {
                    allSelected = false;
                    break;
                }
            }
        }
        this.allSelected = allSelected;
    }

    /** Verifica se possui algum usuário selecionado */
    private possuiAlgumUsuarioSelecionado(): boolean {
        // Agrupamentos
        for (let i = 0; i < this.agrupamentosPopula?.length; i++) {
            const agrupamentoPopula = this.agrupamentosPopula[i];
            // Usuários
            for (let j = 0; j < agrupamentoPopula.usuarios?.length; j++) {
                const entityPopula = agrupamentoPopula.usuarios[j];
                if (entityPopula.selected && !entityPopula.exists) {
                    return true;
                }
            }
        }

        return false;
    }


    /** Adiciona os usuários selecionados */
    adicionarClick() {
        if (!this.possuiAlgumUsuarioSelecionado()) {
            this.messageService.info('Selecione pelo menos um usuário para adicionar ou clique em cancelar se não desejar adicionar nenhum usuário', 'Informação');
            return;
        }

        const btn = new ButtonLoader('#btnAdicionarUsuarioPopulaAgruapmentoPerfilModal');
        btn.loading('Adicionando');

        const entities: Usuario[] = [];
        this.agrupamentosPopula?.forEach(agrupamentoPopula => {
            agrupamentoPopula.usuarios?.forEach(entityPopula => {
                if (entityPopula.selected && !entityPopula.exists) {
                    entities.push(entityPopula.usuario);
                }
            });
        });

        btn.reset();
        this.close();

        this.adicionar.emit(entities);
    }
}
